export default __webpack_public_path__ + "images/0xf97d438bc03ad0f75b83ce5714c9619880b305bc.png";